import { render, staticRenderFns } from "./BindingServiceAndSupplier.vue?vue&type=template&id=7fc22fd6&scoped=true&"
import script from "./BindingServiceAndSupplier.vue?vue&type=script&lang=js&"
export * from "./BindingServiceAndSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc22fd6",
  null
  
)

export default component.exports